module.exports = __webpack_public_path__ + "static/media/extintor.bc443635.png";